import Panel from '../Panel';
import ClientInfoTab from './tabs/ClientInfoTab';
import ContactInfoTab from './tabs/ContactInfoTab';
import MedicalInfoTab from './tabs/MedicalInfoTab';
import ApplicationStatusTab from './tabs/ApplicationStatusTab';
import FinancialInfoTab from './tabs/FinancialInfoTab';
import AgreementsTab from './tabs/AgreementsTab';
import InsuranceInfoTab from './tabs/InsuranceInfoTab';
import { ApplicationCompletionStatus } from '~/types/application-completion';
import { ITeamMembersResponse } from '~/types/campaigns';

interface Props {
    patient: any;
    metadata: any;
    campaign: any;
    campaignRequest: any;
    coordinator: any;
    application: any;
    campaignApproval?: any; // Campaign approval by HHL staff (NOT application completion)
    teamMembers?: ITeamMembersResponse | null;
    completionStatus?: ApplicationCompletionStatus | null;
    refreshCompletionStatus?: () => void;
    refreshTeamMembers?: () => void;
    onCampaignRequestUpdate?: (updatedCampaignRequest: any) => void;
    selectedSections: string[];
}

const PrimaryPanel: React.FC<Props> = ({
    patient,
    metadata,
    campaign,
    campaignRequest,
    coordinator,
    application,
    campaignApproval,
    teamMembers,
    completionStatus,
    refreshCompletionStatus,
    refreshTeamMembers,
    onCampaignRequestUpdate,
    selectedSections,
}) => {
    // Map section keys to their corresponding components
    const shouldShowSection = (sectionKey: string) => {
        return selectedSections.length === 0 || selectedSections.includes(sectionKey);
    };

    return (
        <Panel>
            <div className='space-y-7.5'>
                {/* Application Status Section - Always show */}
                <ApplicationStatusTab
                    application={application}
                    completionStatus={completionStatus}
                />

                {/* Client Info Section */}
                {shouldShowSection('profile') && (
                    <ClientInfoTab
                        campaign={campaign}
                        patient={patient}
                        metadata={metadata}
                        application={application}
                        completionStatus={completionStatus}
                        teamMembers={teamMembers}
                        onDataSaved={refreshCompletionStatus}
                    />
                )}

                {/* Contact Info Section */}
                {shouldShowSection('contact') && (
                    <ContactInfoTab
                        patient={patient}
                        metadata={metadata}
                        campaign={campaign}
                        application={application}
                        completionStatus={completionStatus}
                        teamMembers={teamMembers}
                        onDataSaved={refreshTeamMembers}
                    />
                )}

                {/* Medical Professional Section */}
                {shouldShowSection('medpro') && (
                    <MedicalInfoTab
                        metadata={metadata}
                        patient={patient}
                        campaign={campaign}
                        campaignRequest={campaignRequest}
                        application={application}
                        completionStatus={completionStatus}
                        onDataSaved={refreshCompletionStatus}
                    />
                )}

                {/* Insurance Section */}
                {shouldShowSection('insurance') && (
                    <InsuranceInfoTab
                        campaignRequest={campaignRequest}
                        patient={patient}
                        metadata={metadata}
                        application={application}
                        campaignApproval={campaignApproval}
                        completionStatus={completionStatus}
                        onDataSaved={refreshCompletionStatus}
                    />
                )}

                {/* Financial Section */}
                {shouldShowSection('financial') && (
                    <FinancialInfoTab
                        metadata={metadata}
                        patient={patient}
                        campaignRequest={campaignRequest}
                        application={application}
                        completionStatus={completionStatus}
                        onDataSaved={refreshCompletionStatus}
                    />
                )}

                {/* Agreements Section */}
                {shouldShowSection('agreement') && (
                    <AgreementsTab
                        campaignRequest={campaignRequest}
                        patient={patient}
                        metadata={metadata}
                        application={application}
                        campaignApproval={campaignApproval}
                        completionStatus={completionStatus}
                        onDataSaved={refreshCompletionStatus}
                    />
                )}
            </div>
        </Panel>
    );
};

export default PrimaryPanel;
